export const formatSEK = (value: number): string => {
  const formatter = new Intl.NumberFormat('sv-SE', {
    currency: 'SEK',
    style: 'currency'
  })

  return formatter.format(value)
}
